import React from 'react';

import {
    Card,
    message,
    Button
} from 'antd';

import {
    _getStockIntegration,
    _getStockIntegrationUpdateHistories,
    _postNewStockIntegration,
    _postEditStockIntegration,
} from '../../services'

import UpdateHistoryTable from './update-history-table';
import StockIntegrationForm from './form';

class StockIntegrationProfile extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            stockIntegration: {},

            updateHistories: [],
            updateHistoriesCount: 0,

            page: 1,
            limit: 3,

            editMode: this.props.supplierId == 'new' ? true : false
        }
    }

    render() {

        const column1 = [
            { key: 'integrationType', title: 'Integration Type' },
            { key: 'fileEndpoint', title: 'File Endpoint' },
            { key: 'updateSchedule', title: 'Update Schedule', commaSeperated: true },
            { key: 'incomingEmailAddresses', title: 'Incoming Email Addresses', commaSeperated: true },
        ]
        const column2 = [
            { key: 'identifierColumn', title: 'Identifier Column' },
            { key: 'quantityColumn', title: 'Quantity Column' },
            { key: 'timestampColumn', title: 'Timestamp Column' },
            { key: 'rowStart', title: 'Row Start' },
            { key: 'timestampFormat', title: 'Timestamp Format' },
        ]

        const { stockIntegration } = this.state

        return (
            <div>
                {this.state.editMode &&  <Card>
                    <StockIntegrationForm
                        stockIntegration={this.state.stockIntegration}
                        supplierId={this.props.supplierId}
                        onSubmit={this.onFormSubmit}
                    />
                </Card>}
                {this.props.supplierId != 'new' && <div>
                    <Card 
                        title={<Button onClick={() => this.setState({ editMode: !this.state.editMode })}>Edit</Button>}
                        style={{ marginTop: 8 }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridColumnGap: 8 }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                                {column1.map(_col => this.renderHeaderItem(_col.title, stockIntegration[_col.key], _col.commaSeperated))}
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                                {column2.map(_col => this.renderHeaderItem(_col.title, stockIntegration[_col.key], _col.commaSeperated))}
                            </div>
                        </div>
                    </Card>
                    <Card style={{ marginTop: 8 }}>
                        <UpdateHistoryTable
                            loading={this.state.loading}
                            updateHistories={this.state.updateHistories}
                            updateHistoriesCount={this.state.updateHistoriesCount}
                            page={this.state.page}
                            limit={this.state.limit}
                            onTablePageChange={this.onTablePageChange}
                        />
                    </Card>
                </div>
                }

            </div>
        )
    }

    componentDidMount() {

        if (this.props.supplierId == 'new') {
            return 
        }

        Promise.all([
            _getStockIntegration({ supplierId: this.props.supplierId }),
            this.getUpdateHistories()
        ])
        .then(([data, res]) => {
            this.setState({
                stockIntegration: data.data
            })
        })
    }

    getUpdateHistories = () => {

        this.setState({
            loading: true
        }, () => {
            
            const { page, limit } = this.state
    
            _getStockIntegrationUpdateHistories({ page, limit, supplierId: this.props.supplierId })
            .then(updateHistories => {
                this.setState({
                    updateHistories: updateHistories.data.docs,
                    updateHistoriesCount: updateHistories.data.count,
                    loading: false
                })
            })

        })

    }

    renderHeaderItem = (title, text, commaSeperated=false) => {

        if (text && commaSeperated) {
            text = text.reduce((acc,cur,index) => {
                if (index==0) {
                    return `${cur}`
                }
                return `${acc},${cur}`
            },``)
        }

        return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gridColumnGap: 8 }}>
                <div style={{textAlign: 'right' }}><b>{title}:</b></div>
                <div>{text}</div>
            </div>
        )
    }

    onTablePageChange = (page) => {
        this.setState({
            page: page
        }, this.getUpdateHistories)
    }

    onFormSubmit = (values) => {

        // NEW
        if (this.props.supplierId=='new') {
            _postNewStockIntegration({
                supplierId: values.supplierId,
                integrationType: values.integrationType,
                identifierType: values.identifierType,
                identifierColumn: values.identifierColumn,
                quantityColumn: values.quantityColumn,
                timestampColumn: values.timestampColumn,
                rowStart: values.rowStart,
                timestampFormat: values.timestampFormat,
                updateSchedule: values.updateSchedule,
                fileEndpoint: values.fileEndpoint,
                incomingEmailAddresses: values.incomingEmailAddresses,
                doNotNotifyFlag: values.doNotNotifyFlag
            })
            .then(_newStockIntegration => {
                let supplierId = _newStockIntegration.data.supplierId

                window.open(`/tech/stock-integration/${supplierId}`)
            })
        }
        // EDIT
        if (this.props.supplierId!='new') {
            _postEditStockIntegration({
                supplierId: values.supplierId,
                integrationType: values.integrationType,
                identifierType: values.identifierType,
                identifierColumn: values.identifierColumn,
                quantityColumn: values.quantityColumn,
                timestampColumn: values.timestampColumn,
                rowStart: values.rowStart,
                timestampFormat: values.timestampFormat,
                updateSchedule: values.updateSchedule,
                fileEndpoint: values.fileEndpoint,
                incomingEmailAddresses: values.incomingEmailAddresses,
                doNotNotifyFlag: values.doNotNotifyFlag
            })
            .then(_udpatedStockIntegration => {
                this.setState({
                    stockIntegration: _udpatedStockIntegration.data
                })
                message.success('Update Successful!', 5)
            })
        }

    }


}

export default StockIntegrationProfile


// WEBPACK FOOTER //
// ./src/components/stock-integration/profile.js